import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";

import { trialsCrudStateConfig } from "../consts";

export const {
  fetchAllActionFactory: fetchTrialsActionFactory,
  updateActionFactory: updateTrialActionFactory // This can be remove when we implement an event-based back-end
} = makeCrudStateActionFactories(trialsCrudStateConfig);
